import { render, staticRenderFns } from "./VsCustomButton.vue?vue&type=template&id=b156c2e2&lang=html&"
import script from "./VsCustomButton.vue?vue&type=script&lang=js&"
export * from "./VsCustomButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports